import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Chip } from '@mui/material'
import { styled } from '@mui/material/styles'

import {
  FlagIcon,
  ThermometerIcon,
} from '~/components/elements/Icons/generated'
import type { InventoryOrderFlags } from '~/types'

const StyledLabelChip = styled(Chip)(({ theme }) => ({
  color: 'white',
  backgroundColor: theme.colors.important,
  borderRadius: 1,
  fontWeight: theme.typography.fontWeightBold,
  minWidth: 0,
  '& .MuiChip-icon': {
    color: 'white',
  },
}))

export const OrderItemFlags = ({
  storeCold,
  controlled,
}: InventoryOrderFlags) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" gap={1}>
      {controlled && (
        <StyledLabelChip
          icon={<FlagIcon />}
          label={t('Common:CONTROLLED_SUBSTANCE')}
          size="small"
          title={t('Common:CONTROLLED_SUBSTANCE')}
        />
      )}
      {storeCold && (
        <StyledLabelChip
          icon={<ThermometerIcon />}
          label={t('Common:STORE_COLD')}
          size="small"
          title={t('Common:STORE_COLD')}
        />
      )}
    </Box>
  )
}
